import { render, staticRenderFns } from "./ProductServicesTabComponent.vue?vue&type=template&id=32f593e3&scoped=true&"
import script from "./ProductServicesTabComponent.vue?vue&type=script&lang=js&"
export * from "./ProductServicesTabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f593e3",
  null
  
)

export default component.exports